<template>
  <section class="document-info document-card"  ref="classDocumentInfo">
    <template v-if="card">
      <div v-if="card.isChange || card.isAttachment" class="dc__item">
        <div class="dc-item__label">{{ title }}</div>
        <div class="dc__content">
          <router-link :to="makeDocumentCardRoute(card.parentDocumentId)">
            {{ card.parentDocumentTitle }}
          </router-link>
        </div>
      </div>

      <div v-if="project" class="document-info__note message _attention">
        <span>
          {{ projectText }}
          <a :href="project.url" target="_blank">{{ projectLinkText }}</a>
        </span>
      </div>

      <div v-if="card.type || card.number || card.title" class="dc__item">
        <span v-if="card.designation" class="snippet__designation">
          <span>{{ card.designation }}</span>
        </span>

        <span v-else-if="card.type || card.number" class="snippet__designation">
          <span v-if="card.type">{{ card.type }}</span>
          &nbsp;
          <span v-if="card.number">{{ card.number }}</span>
        </span>
        <br />
        <div
          v-if="card.synonyms && card.synonyms.length > 0"
          class="dc__item dc-item__synonyms"
        >
          <div>
            <span
              v-for="(item, index) in card.synonyms"
              v-if="index <= count"
              :key="index"
              class="dc-item__synonyms-item AddComma()"
            >{{ item }}</span
            >
          </div>
          <a
            v-if="card.synonyms.length > 4 && count <= 4"
            href="#"
            class="dc-show-more__link"
            @click="changeCountOfSynomys(card.synonyms.length - 1)"
          >Показать все</a
          >
          <a
            v-if="count > 4"
            href="#"
            class="dc-show-more__link"
            @click="changeCountOfSynomys(4)"
          >Скрыть</a
          >
        </div>
        <span class="dc__name">{{ card.title }}</span>
      </div>

      <list-items
        v-if="card.approvedText && card.approvedText.length"
        :items="card.approvedText"
        class="dc__item dc__list dc__approved"
        title="Утвержден"
      />

      <div 
        v-if="currentStatus" 
        class="dc__item"
      >
        <div class="dc-item__label">
          Статус
        </div>
        
        <div class="dc__content">
          {{ currentStatus }}
        </div>
      </div>

      <div v-if="card.hasAnnotation" 
        class="dc__item dc_info-continuity"
        @click="handleAnnotationClick">
        <router-link :to="annotationInfoRoute">
          Примечания и особенности применения
        </router-link>
      </div>

      <div 
        v-if="card.organization" 
        class="dc__item"
      >
        <div class="dc-item__label">
          Разработчик
        </div>
        
        <div class="dc__content">
          {{ card.organization }}
        </div>
      </div>

      <list-items
        v-if="card.publications && card.publications.length"
        :items="card.publications"
        :format-html="true"
        class="dc__item dc__list dc__publications"
        title="Сведения о публикациях"
      />

      <div
        v-if="card.area"
        class="dc__item"
        :class="{ _collapsed: card.area && card.area.length > 400 }"
      >
        <div class="dc-item__label">Область применения</div>
        <div
          class="dc-item__content"
          :class="{ _opened: cardAreaOpened }"
          v-html="card.area"
        ></div>
        <div
          class="dc__show-more _full-card"
          :class="{ _opened: cardAreaOpened }"
        >
          <a
            class="dc-show-more__link"
            href="#"
            @click.prevent="cardAreaOpened = !cardAreaOpened"
          >
            {{ cardAreaOpened ? 'Свернуть' : 'Показать все' }}
          </a>
        </div>
      </div>

      <div
        v-if="card.comment"
        class="dc__item"
        :class="{ _collapsed: card.comment && card.comment.length > 300 }"
      >
        <div class="dc-item__label">Комментарий</div>
        <div
          class="dc-item__content"
          :class="{ _opened: cardCommentOpened }"
          v-html="card.comment"
        ></div>
        <div
          class="dc__show-more _full-card"
          :class="{ _opened: cardCommentOpened }"
        >
          <a
            class="dc-show-more__link"
            href="#"
            @click.prevent="cardCommentOpened = !cardCommentOpened"
          >
            {{ cardCommentOpened ? 'Свернуть' : 'Показать все' }}
          </a>
        </div>
      </div>

      <list-items
        v-if="relationComparisonWithNew && relationComparisonWithNew.length"
        v-slot="{ item }"
        :items="relationComparisonWithNew"
        class="dc__item dc__list"
        title="Сравнение с новым документом"
      >
        <router-link :to="makeDocumentRoute(item.id)" v-text="item.title" />
      </list-items>

      <list-items
        v-if="relationComparisonWithOld && relationComparisonWithOld.length"
        v-slot="{ item }"
        :items="relationComparisonWithOld"
        class="dc__item dc__list"
        title="Сравнение со старым документом"
      >
        <router-link :to="makeDocumentRoute(item.id)" v-text="item.title" />
      </list-items>

      <div
        v-if="card.hasContinuity"
        class="dc__item dc_info-continuity"
        @click="handleContinuityClick"
      >
        <router-link :to="continuityInfoRoute">
          Преемственность
        </router-link>
      </div>

      <div v-if="discussion" class="document-info__discussion">
        <a
          class="document-info__discussion-button"
          :href="discussion.url"
          target="_blank"
          rel="noopener"
        >
          <svg width="18" height="18"><use xlink:href="#comments" /></svg>
          {{
            discussion.commentsCount
              | pluralForm('комментарий', 'комментария', 'комментариев', true)
          }}
        </a>
      </div>

      <div class="dc__footer">
        <div>
          Открыть в программе NormaCS 4.x:
          <a :href="card.normacsUrl" id = 'sideNormaCsLink' v-text="card.normacsUrl"></a>
        </div>
      </div>
    </template>

    <div v-else-if="loadErrors.info.status" class="message _error">
      Ошибка: {{ loadErrors.info.message }}
    </div>

    <loader-dots v-else>
      Загрузка информации...
    </loader-dots>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';
import { ROUTE_DOCUMENT_HASH_CONTINUITY } from '@src/routes';

import DocumentProject from '@@/document/mixins/DocumentProject';
import DocumentRoute from '@@/document/mixins/DocumentRoute';
import NormaCsLinkHandler from '@@/document/mixins/NormaCsLinkHandler';

import ListItems from '@@/shared/list/ListItems';
import LoaderDots from '@@/shared/loaders/LoaderDots';

import ListItemsLoadable from '@@/shared/list/ListItemsLoadable';

export default {
  components: {
    ListItems,
    LoaderDots
  },

  mixins: [DocumentProject, DocumentRoute, NormaCsLinkHandler],

  props: {
    card: {
      required: true
    }
  },

  data() {
    return {
      cardCommentOpened: false,
      cardAreaOpened: false,
      count: 4,
      bBeg: true
    };
  },

  computed: {
    ...mapGetters(['loadErrors']),
    showMNavBack() {
      return this.$store.getters.getWindowSize < 800;
    },
    /**
     * @returns {ApiDocumentProject|null}
     */
    project() {
      return this.card ? this.card.project : null;
    },
    projectText() {
      return this.makeProjectText(this.project);
    },
    projectLinkText() {
      return this.makeProjectLinkText(this.project);
    },
    /**
     * @returns {ApiDocumentDiscussion|null}
     */
    discussion() {
      return this.card ? this.card.discussion : null;
    },
    /** @returns {Array<ApiDocumentRelation>} */
    relationComparisonWithNew() {
      return this.card ? this.card.getRelationComparisonWithNew() : null;
    },
    /** @returns {Array<ApiDocumentRelation>} */
    relationComparisonWithOld() {
      return this.card ? this.card.getRelationComparisonWithOld() : null;
    },
    continuityInfoRoute() {
      return `/document/${this.card.id}/card#continuity`;
    },
    annotationInfoRoute() {
      return `/document/${this.card.id}/card#annotation`;
    },
    currentStatus() {
      let cond = this.card && this.card.statusHistory && Array.isArray(this.card.statusHistory) && this.card.statusHistory[0]
    
      return cond? this.card.statusHistory[0].split('-')[0].trim(): ''
    },
    title() {
      return this.card.isChange ? 'Изменяемый документ' :
        this.card.isAttachment ? 'Приложение к документу' :
        'Документ';
    },
  },

  updated() {
    if (this.bBeg) {
      this.bBeg = false;
      this.initNormaCsLinkHandler(this.$refs.classDocumentInfo);
    }
  },

  methods: {
    handleContinuityClick() {
      this.$emit('show-continuity');
    },
    handleAnnotationClick() {
      this.$emit('show-annotation');
    },
    changeCountOfSynomys(int) {
      this.count = int;
    },
    back() {
      window.history.back();
    }
  }
};
</script>
